// Menu items are given as plain objects; this drops the empty slots a caller leaves behind
// (a conditional option that did not apply) and gives every row a stable key.
export const normalizeMenuItems = (items = []) =>
    (Array.isArray(items) ? items : []).filter(Boolean).map((item, index) => ({
        ...item,
        key: item.id ?? item.value ?? item.label ?? index,
    }));

// select2-era callers pass `[['data-action', 'x'], ['data-value', 1]]`; objects pass through.
export const toDataAttributes = (attributes) => {
    if (!attributes) return {};
    return Array.isArray(attributes) ? Object.fromEntries(attributes) : attributes;
};
